export default function (val) {
  if (!val) return ''
  return val.toLowerCase()
}
